module.exports = __webpack_public_path__ + "static/media/image_start.d267a165.jpg";